import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/tenant-customers', {
          params: payload,
        })
        .then((response) => {
          commit('SET_CUSTOMERS', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  verifyPeppolId({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/peppol-submissions/verify-id/' + id)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRecord(context, customerId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/tenant-customers/${encodeURIComponent(customerId)}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRecords({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/tenant-customers/bulk', { bulk: items })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/tenant-customers', item)
        .then((response) => {
          commit('ADD_CUSTOMER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRecord(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/tenant-customers/${encodeURIComponent(item.customerId)}`, item)
        .then((response) => {
          //commit('UPDATE_CUSTOMER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeRecord({ commit }, customerId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/tenant-customers/${encodeURIComponent(customerId)}`)
        .then((response) => {
          commit('DELETE_CUSTOMER', customerId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async searchTin(context, { identificationNumber, registrationType }) {
    try {
      console.log({
        idType: registrationType,
        id: identificationNumber
      });
      const response = await axios.post('/lhdn/tin/search', {
        idType: registrationType,
        id: identificationNumber
      });

      console.log('TIN Search Result:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error searching TIN:', error.response?.data || error.message);
    }
  },
  exportInvoices(context, customerId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/billing-docs/customer/${encodeURIComponent(customerId)}/export`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
